function buildNodeHierarchy(arry = []) {
  const roots = [],
    nodes = {}

  for (let i = 0, len = arry.length; i < len; ++i) {
    let item = arry[i],
      p = item.parent,
      target = !p ? roots : nodes[p] || (nodes[p] = [])

    target.push({ ...item })
  }

  const findChildren = parent => {
    if (nodes[parent.id]) {
      parent.nodes = nodes[parent.id]
      for (let i = 0, len = parent.nodes.length; i < len; ++i) {
        findChildren(parent.nodes[i])
      }
    }
  }

  for (let i = 0, len = roots.length; i < len; ++i) {
    findChildren(roots[i])
  }

  return roots
}

export default buildNodeHierarchy



// WEBPACK FOOTER //
// ./src/utils/buildNodeHierarchy.js